import { render, staticRenderFns } from "./pendingProducts.vue?vue&type=template&id=7edabf16&scoped=true"
import script from "./pendingProducts.vue?vue&type=script&lang=js"
export * from "./pendingProducts.vue?vue&type=script&lang=js"
import style0 from "./pendingProducts.vue?vue&type=style&index=0&id=7edabf16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edabf16",
  null
  
)

export default component.exports